import React, { Component } from 'react';

import UnitySplitPane from '../UnitySplitPane/UnitySplitPane';
import UnityNotificationsHandler from './UnityNotificationsHandler';

export default class UnityNotificationsSplitPane extends Component {
  render() {
    const { mainNotifications = {}, paneNotifications = {}, main, pane, ...splitPaneProps } = this.props;

    return (
      <UnitySplitPane
        main={
          !!mainNotifications.target ? (
            <UnityNotificationsHandler {...mainNotifications}>{main}</UnityNotificationsHandler>
          ) : (
            main
          )
        }
        pane={
          !!paneNotifications.target ? (
            <UnityNotificationsHandler {...paneNotifications}>{pane}</UnityNotificationsHandler>
          ) : (
            pane
          )
        }
        {...splitPaneProps}
      />
    );
  }
}